/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const DELETE_ACTION_GENERATOR = gql`
  mutation DeleteActionGenerator($input: DeleteObjectInput!) {
    deleteActionGenerator(data: $input)
  }
`
